import { styled } from "@mui/material/styles";
import { Box, TextField, Switch, ToggleButtonGroup, ToggleButton, Button, Select, FormControl } from "@mui/material";

export const FilterBarContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  width: "80%",
  gap: "16px",
  padding: "8px",
  margin: "0px 0px 0px 20px",
  backgroundColor: theme.palette.jigsaw.white,
  boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.1)",
  borderRadius: "8px",
  border: `1px solid ${theme.palette.jigsaw.green}`,
}));

export const FullContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "16px"
}));

export const SearchContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  width: "25%",
  border: `1px solid ${theme.palette.jigsaw.green}`,
  borderRadius: "850px",
  padding: "4px 12px",
  marginLeft: "20px",
  marginRight: "20px",
}));

export const StyledTextField = styled(TextField)({
  width: "100%",
  "& input": {
    padding: "4px",
  },
});

export const ToggleContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginLeft: "20px",
  marginRight: "20px",
});

export const StyledSwitch = styled(Switch)({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#C0E218",
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#C0E218",
  },
});

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({theme}) => ({
  borderRadius: "999px",
  backgroundColor: theme.palette.jigsaw.white,
  height: "35px",
  width: "25%",
  marginLeft: "20px",
  marginRight: "20px",
}));

export const StyledToggleButton = styled(ToggleButton)(({ selected, theme }) => ({
  textTransform: "none",
  width: "33.33%",
  borderRadius: "999px",
  color: selected ? theme.palette.jigsaw.green : theme.palette.jigsaw.green,
  backgroundColor: selected ? theme.palette.jigsaw.green: "transparent",
}));

export const StyledButtonContainer = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.jigsaw.green,
  height:"60px",
  width: '308px',
  color: "white",
  borderRadius: "10px",
  margin: "0px 20px 0px 0px",
  textTransform: "none",
  padding: "6px",
  "&:hover": { backgroundColor: "#A8C70F" },
}));

export const SearchButtonContainer = styled(Button)(({ theme }) => ({
  width: '200px',
  backgroundColor: theme.palette.jigsaw.white,
  borderRadius: "10px",
  margin: "0px 20px 0px 0px",
  textTransform: "none",
  padding: "6px",
  color: "black",
  border: `1px solid ${theme.palette.jigsaw.green}`,
  "&:hover": {
    backgroundColor: "#A8C70F",
  },
}));

export const StyledSelectContainer = styled(Box)(() => ({
  minWidth: 160,
}));

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: theme.palette.grey[400],
    },
    "&:hover fieldset": {
      borderColor: theme.palette.jigsaw.green,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.jigsaw.green,
      borderWidth: 2,
    },
  },
  "& .MuiInputLabel-root": {
    color: theme.palette.grey[600],
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: theme.palette.jigsaw.green,
  },

  "& .MuiInput-underline:after": {
    borderBottomColor: theme.palette.jigsaw.green,
  },
  "& .MuiInput-underline:before": {
    borderBottomColor: theme.palette.grey[400],
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
    borderBottomColor: theme.palette.jigsaw.green,
  },
}));

export const StyledSelect = styled(Select)(() => ({}));